// Momentum/intertia drag to scroll
document.addEventListener('DOMContentLoaded', function (event) {
	const inertiaX = document.querySelectorAll('.inertia_x');
	let isDown = false;
	let startX;
	let scrollLeft;

	for (const slider of inertiaX) {
		slider.addEventListener(
			'mousedown',
			(e) => {
				isDown = true;
				slider.classList.add('active');
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
				cancelMomentumTracking();
			},
			{ passive: true }
		);

		slider.addEventListener(
			'mouseleave',
			() => {
				isDown = false;
				// slider.classList.remove('active');
			},
			{ passive: true }
		);

		slider.addEventListener(
			'mouseup',
			() => {
				isDown = false;
				// slider.classList.remove('active');
				beginMomentumTracking();
			},
			{ passive: true }
		);

		slider.addEventListener(
			'mousemove',
			(e) => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = x - startX; //scroll-fast
				const prevScrollLeft = slider.scrollLeft;
				slider.scrollLeft = scrollLeft - walk;
				velX = slider.scrollLeft - prevScrollLeft;
			},
			{ passive: true }
		);

		// Momentum/intertia
		var velX = 0;
		var momentumID;

		slider.addEventListener(
			'wheel',
			(e) => {
				cancelMomentumTracking();
			},
			{ passive: true }
		);

		function beginMomentumTracking() {
			cancelMomentumTracking();
			momentumID = requestAnimationFrame(momentumLoop);
		}

		function cancelMomentumTracking() {
			cancelAnimationFrame(momentumID);
		}

		function momentumLoop() {
			slider.scrollLeft += velX * 2;
			velX *= 0.95;
			if (Math.abs(velX) > 0.5) {
				momentumID = requestAnimationFrame(momentumLoop);
			}
		}
	}
});

// Mouse wheel
// const scrollContainer = document.querySelectorAll('.inertia_x');
// scrollContainer.addEventListener('wheel', (evt) => {
// 	// scrollContainer.scrollLeft += evt.deltaY;
// 	window.requestAnimationFrame(() => {
// 		scrollContainer.scrollTo({
// 			top: 0,
// 			left: scrollContainer.scrollLeft + evt.deltaY * 2,
// 			behavior: 'smooth',
// 		});
// 	});
// });
